export default __webpack_public_path__ + "static/media/DSC_9002-edited.415d97f2.jpg";